import { View, html } from 'rune-ts';
import { AdultVerificationIcon18Plus, AdultVerificationIcon19 } from '../../atoms/Icon';
import c from './AdultVerificationThumbnail.module.scss';

interface AdultVerificationIconProps {
  klass?: string;
}

export class AdultVerificationIcon extends View<AdultVerificationIconProps> {
  constructor(props: AdultVerificationIconProps = {}) {
    super(props);
  }

  override template() {
    const klass = this.data.klass ?? c.icon;

    return html`
      <span class="${klass}">
        ${ET.lang === 'kr' ? AdultVerificationIcon19 : AdultVerificationIcon18Plus}
      </span>
    `;
  }
}
